module.exports = __webpack_public_path__ + "img/landingpage_bg.85de35c3.jpg";